module.exports = __webpack_public_path__ + "img/tokyu-vacations-bg.869f655e.png";